<template>
	<ProcessCreatePage>
		<Header :title="$t('new_comprehensive_sign_location').toString()"> </Header>
		<div class="main">
			<default-or-value-form
				ref="form"
				v-model="model"
				:default-value="defaultCity"
				:placeholder="$t('location_name').toString()"
				:force-custom-value="isUserAllowedInLevel2"
				v-if="defaultCity"
			>
				<template #default>
					<label>{{ $t('on_site') }} {{ $store.getters.repairShopLabel }}:<br /></label>
					<span class="font-semibold">{{ defaultCity }}</span>
				</template>
				<template #custom>
					<p>{{ $t('elsewhere') }} {{ $store.getters.repairShopLabel }}es: <br /></p>
				</template>
			</default-or-value-form>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="false"
			:is-back-button="true"
		/>
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import Validate from '@/mixins/Validate';
import DefaultOrValueForm from '@/components/damagecases/forms/DefaultOrValueForm';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'ProcessCreateComprehensiveSignLocation',
	components: { DefaultOrValueForm, ProcessCreatePage, Header, Footer },
	mixins: [AppContainerMixin, Validate, Authentication],
	data() {
		return {
			model: null,
		};
	},
	computed: {
		defaultCity() {
			return this.$store.getters.getUser.person.company?.city.name;
		},
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateComprehensiveSignLocation', this.model);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>
